import { render, staticRenderFns } from "./AgentLoader.vue?vue&type=template&id=1a5d25e8&scoped=true&"
import script from "./AgentLoader.vue?vue&type=script&lang=js&"
export * from "./AgentLoader.vue?vue&type=script&lang=js&"
import style0 from "./AgentLoader.vue?vue&type=style&index=0&id=1a5d25e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5d25e8",
  null
  
)

export default component.exports